import { useShallow } from 'zustand/shallow';
import { RatingsState, store } from './store';

export const useRatings = () => {
  const {
    data,
    ratingAverage,
    loading,
    error,
    createRating,
    fetchRatings,
    fetchCandidateRatingAverage,
    reset,
  } = store<RatingsState>(
    useShallow((state) => ({
      data: state.data,
      ratingAverage: state.ratingAverage,
      loading: state.loading,
      error: state.error,
      createRating: state.createRating,
      fetchRatings: state.fetchRatings,
      fetchCandidateRatingAverage: state.fetchCandidateRatingAverage,
      reset: state.reset,
    })),
  );

  return {
    data,
    loading,
    error,
    ratingAverage,
    createRating,
    fetchRatings,
    fetchCandidateRatingAverage,
    reset,
  };
};
